import React from 'react';
import { ArrowLeft, HelpCircle, ChevronDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';

export const FAQs = () => {
  const navigate = useNavigate();

  const faqs = [
    {
      question: 'What types of ethnic wear do you offer?',
      answer: 'We specialize in premium women\'s ethnic wear including Designer Suits, Pakistani Suits, Anarkali Suits, Lehengas, Sarees, Georgette Collection, Silk Collection, Velvet Collection, Tissue Collection, and more. Each piece is carefully curated for quality and craftsmanship.'
    },
    {
      question: 'Do you offer customization services?',
      answer: 'Yes, we offer customization services for select products. Please contact us at +91 9811193388 or ssons1975@gmail.com with your requirements, and our team will assist you with custom sizing and design modifications.'
    },
    {
      question: 'What is your return and exchange policy?',
      answer: 'We maintain a strict No Returns and No Exchange policy on all products. This ensures that each garment maintains its pristine condition and quality standards. We recommend checking the size guide and product details carefully before placing your order.'
    },
    {
      question: 'How do I choose the right size?',
      answer: 'Please refer to our detailed Size Guide which includes measurements for sizes L to 3XL. We provide bust, waist, hip, and length measurements. If you\'re between sizes, we recommend ordering the larger size. For assistance, feel free to contact our customer service team.'
    },
    {
      question: 'What payment methods do you accept?',
      answer: 'We accept various payment methods including Credit/Debit Cards, Net Banking, UPI, Digital Wallets, and Cash on Delivery (COD) for eligible orders. All transactions are secure and encrypted.'
    },
    {
      question: 'How long does shipping take?',
      answer: 'We offer Pan India and Overseas shipping. Domestic orders typically take 5-7 business days for delivery. International shipping times vary by destination (10-15 business days). We work with reliable and reputed courier partners to ensure safe delivery.'
    },
    {
      question: 'Do you ship internationally?',
      answer: 'Yes, we ship internationally to most countries. Shipping charges and delivery times vary based on the destination. Please contact us for specific international shipping rates and estimated delivery times for your location.'
    },
    {
      question: 'How can I track my order?',
      answer: 'Once your order is shipped, you will receive a tracking number via email and SMS. You can use this tracking number on the courier partner\'s website to monitor your shipment\'s progress.'
    },
    {
      question: 'What if my order is damaged during shipping?',
      answer: 'While we maintain a no returns policy, if your order arrives damaged due to shipping, please contact us immediately at ssons1975@gmail.com with photos of the damage. We will work with you to resolve the issue on a case-by-case basis.'
    },
    {
      question: 'How do I care for my ethnic wear?',
      answer: 'Most of our garments require dry cleaning only, especially those with heavy embroidery and embellishments. Always check the care label on your garment. Store in a cool, dry place away from direct sunlight. Avoid contact with perfumes and deodorants.'
    },
    {
      question: 'Do you have a physical store?',
      answer: 'Yes, you can visit us at our store: 52, Krishna Cloth Market, Chandni Chowk, Delhi - 110006. Our store hours are Monday-Saturday: 11:30 AM - 8:00 PM, Sunday: CLOSED.'
    },
    {
      question: 'How can I contact customer support?',
      answer: 'You can reach us via Phone: +91 9811193388, Email: ssons1975@gmail.com, or visit our Contact Us page to submit an inquiry. Our team typically responds within 24 hours.'
    }
  ];

  return (
    <div className="min-h-screen bg-[#FAF9F7] pt-32 pb-16">
      <div className="container mx-auto px-4">
        <Button
          variant="ghost"
          className="mb-6 text-[#2C2C2C] hover:text-[#C4B5A0]"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>

        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <div className="flex justify-center mb-6">
              <div className="bg-[#F5F3F0] p-6 rounded-full">
                <HelpCircle className="h-12 w-12 text-[#C4B5A0]" />
              </div>
            </div>
            <h1 className="text-4xl md:text-5xl font-seasons font-light text-[#2C2C2C] mb-4">
              Frequently Asked Questions
            </h1>
            <p className="text-[#8B7D6B] font-montserrat">
              Find answers to common questions about our products and services
            </p>
          </div>

          <Card className="bg-white border-none shadow-lg p-8">
            <Accordion type="single" collapsible className="space-y-4">
              {faqs.map((faq, index) => (
                <AccordionItem key={index} value={`item-${index}`} className="border-b border-[#F5F3F0]">
                  <AccordionTrigger className="text-left font-montserrat text-[#2C2C2C] hover:text-[#C4B5A0] py-4">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#8B7D6B] font-montserrat leading-relaxed pb-4">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Card>

          <div className="mt-8 text-center">
            <p className="text-[#8B7D6B] font-montserrat mb-4">
              Didn't find what you're looking for?
            </p>
            <Button
              className="bg-[#C4B5A0] hover:bg-[#B0A090] text-white font-montserrat tracking-wider uppercase"
              onClick={() => navigate('/contact')}
            >
              Contact Us
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};